// « CONFIGURATION » — what the client adds to the server's checks: where each
// one leads. The checks themselves — passing or not, which records, and THE
// ORDER (the setup order, Organizations::SetupCheckService::CHECKS) — are the
// server's; route names are the client's, so the server never sends a path.
import type { RouteLocationRaw } from 'vue-router'
import type { components, paths } from '@/api/schema'

export type SetupCheckMeta =
  paths['/api/setup_check']['get']['responses']['200']['content']['application/vnd.api+json']['meta']
export type SetupCheck = components['schemas']['SetupCheckLine']
export type SetupCheckKey = SetupCheck['key']

/** The checks still to fix — what the header button counts. */
export function failingChecks(checks: readonly SetupCheck[]): SetupCheck[] {
  return checks.filter(check => !check.ok)
}

/** Each check's page — a plain link (v1: no section anchors). A failing check
 *  naming records opens the FIRST one; the rest are one more click away. */
export function setupCheckTarget(check: SetupCheck): RouteLocationRaw {
  const first = check.items[0]?.id
  switch (check.key) {
    case 'contact_email_missing': return { name: 'settings-paper' }
    case 'tax_number_missing': return { name: 'settings-taxes' }
    case 'hq_unlocated': return { name: 'settings-sectors' }
    case 'no_job_types': return { name: 'templates' }
    case 'type_without_crew': return first ? { name: 'template-show', params: { id: first } } : { name: 'templates' }
    case 'season_never_opened': return first ? { name: 'season-show', params: { id: first } } : { name: 'seasons' }
    case 'no_work_crew':
    case 'no_quote_crew': return { name: 'fleet' }
    case 'crew_without_member':
    case 'crew_without_type':
    case 'crew_without_target': return first ? { name: 'crew-show', params: { id: first } } : { name: 'fleet' }
    case 'invitations_pending':
    case 'technician_without_app': return { name: 'settings-members' }
  }
}

/** The names a failing check carries, as one line: « Camion 2 · Ventes +3 ». */
export function itemsSummary(check: SetupCheck): string {
  const names = check.items.map(item => item.label).join(' · ')
  const rest = check.total - check.items.length
  return rest > 0 ? `${names} +${rest}` : names
}
